<div
  class="layout-wrapper"
  [ngClass]="{
    'p-input-filled': config.inputStyle === 'filled',
    'p-ripple-disabled': !config.ripple
  }"
>
  <app-header
    (menuButtonClick)="onMenuButtonClick()"
    (toggleHeaderClick)="onToggleHeaderClick($event)"
  ></app-header>
  <app-menu
    [active]="menuActive"
    (menuToggleClick)="onMenuToggleClick($event)"
    [fullmenu]="fullMenu"
  ></app-menu>
  <div
    class="layout-mask"
    [ngClass]="{ 'layout-mask-active': menuActive }"
    (click)="onMaskClick()"
  ></div>

  <div
    class="layout-content"
    [ngClass]="{
      'm-s-left': slideContentLeft,
      'm-s-right': slideContentRight,
      'hide-header': hiddenHeader
    }"
    id="content-wrap"
  >
    <app-breadcrumb></app-breadcrumb>
    <div
      class="content-section"
      style="overflow-y: auto"
      [ngStyle]="{ minHeight: contentSectionHeight + 'px' }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
